<template>
    <div class="pluralo d-flex">
        <pill></pill>
        <sidebar></sidebar>

        <section class="d-flex flex-column fix-index">
            <div>
                <bar></bar>
                <transition name="fade">
                    <AlertMessage
                        v-if="displayGlobalMessage && !getIsDonwloadingCompanySettings"
                        message="Your profile is missing mandatory billing information. Please update your details to proceed."
                        icon="ico-alert"
                        bold
                    />
                </transition>
            </div>

            <router-view class="flexGrow1" @click.native="clickOnContentArea()"></router-view>
        </section>

        <modal-wrapper></modal-wrapper>
        <floating-notifications v-if="showNotifications"></floating-notifications>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Sidebar from '../common/Sidebar.vue'
import Bar from '../common/Bar.vue'
import Pill from '@/tools/Pill'
import ModalWrapper from '@/tools/modal/ModalWrapper.vue'
import floatingNotifications from '@/tools/notifications/floatingNotifications/floatingNotifications'
import AlertMessage from '@/tools/alertMessage/AlertMessage'

export default {
    data() {
        return {
            companySettingsReady: false
        }
    },
    computed: {
        ...mapGetters([
            'getIsBellNotificationOpen',
            'getCompanySettings',
            'getIsDonwloadingCompanySettings'
        ]),
        validateCenas() {
            return Object.keys(this.getCompanySettings).length > 0;
        },
        showNotifications() {
            // Hide from viewer
            return !this.accessPermissionFilter(['viewer']);
        },
        displayGlobalMessage(){
            const { location, postalCode, companyAddress, registrationNumber } = this.getCompanySettings;
            
            return (
                !location ||
                !postalCode ||
                !companyAddress ||
                !registrationNumber
            );
        }
    },
    methods: {
        ...mapActions([
            'toggleBellNotificationPopup',
        ]),
        clickOnContentArea() {
            if (this.getIsBellNotificationOpen == true) {
                this.toggleBellNotificationPopup(false);
            }
        }
    },
/*     watch: {
        getCompanySettings: {
            immediate: true,
            handler(newVal) {
            // Check if all required fields are present
            if (
                newVal &&
                typeof newVal === 'object' &&
                Object.keys(newVal).length > 0
            ) {
                this.companySettingsReady = true;
            }
            }
        }
        }, */
    components: {
        Pill,
        Bar,
        Sidebar,
        ModalWrapper,
        floatingNotifications,
        AlertMessage
    },
}
</script>

<style lang="scss" scoped>
    .fix-index { 
        z-index: 0; 
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.4s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// Pluralo.vue?1ffe92b8